import React from "react";

const Testimonials = () => {
  const stories = [
    {
      name: "Irfan Malik",
      loc: "Riyadh, KSA",
      msg: "All World Recruiting helped me land a great job in Riyadh. The visa process was smooth and the team was very supportive throughout.",
    },
    {
      name: "Asadullah",
      loc: "Dubai, UAE",
      msg: "Transparent and professional. I highly recommend them for anyone looking for reliable overseas work opportunities.",
    },
    {
      name: "Muhammad Rizwan",
      loc: "Kuwait City, Kuwait",
      msg: "The best agency for Gulf jobs. They provided clear guidance on documentation and kept me updated at every step of my application.",
    },
    {
      name: "Zeeshan Ahmed",
      loc: "Doha, Qatar",
      msg: "Found a great technical role in Qatar through them. Their commitment to finding the right fit for both candidate and employer is impressive.",
    },
  ];

  return (
    <>
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Testimonials
            </h6>
            <h1 className="mb-5">Success Stories</h1>
          </div>
          <div className="row g-4">
            {stories.map((testi, index) => (
              <div
                className="col-lg-6 wow fadeInUp"
                key={index}
                data-wow-delay={`${0.1 * (index + 1)}s`}
              >
                <div
                  className="testimonial-item bg-white border rounded p-4 h-100"
                  style={{
                    transition: "all 0.4s ease",
                    cursor: "default",
                  }}
                  // Inline hover effects
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow =
                      "0 1rem 3rem rgba(0,0,0,.1)";
                    e.currentTarget.style.borderColor = "#86B817"; // Matches primary color
                    e.currentTarget.querySelector(
                      ".quote-icon",
                    ).style.backgroundColor = "#212529";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = "#dee2e6";
                    e.currentTarget.querySelector(
                      ".quote-icon",
                    ).style.backgroundColor = "#86B817";
                  }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="quote-icon bg-primary d-flex align-items-center justify-content-center rounded-circle shadow"
                      style={{
                        width: 60,
                        height: 60,
                        flexShrink: 0,
                        transition: "0.3s",
                      }}
                    >
                      <i className="fa fa-quote-left text-white fs-4"></i>
                    </div>
                    <div className="ps-3 w-100">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h5 className="mb-0">{testi.name}</h5>
                          <small
                            className="text-uppercase text-primary fw-bold"
                            style={{ fontSize: "11px" }}
                          >
                            {testi.loc}
                          </small>
                        </div>
                        <div className="text-warning small">
                          <i className="fa fa-star"></i>
                          <i className="fa fa-star"></i>
                          <i className="fa fa-star"></i>
                          <i className="fa fa-star"></i>
                          <i className="fa fa-star"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p
                    className="mb-0 text-muted fst-italic"
                    style={{ lineHeight: "1.7" }}
                  >
                    "{testi.msg}"
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
